import { render } from "./LegacyMeterIntervalSelection.vue?vue&type=template&id=ed010888"
import script from "./LegacyMeterIntervalSelection.vue?vue&type=script&lang=js"
export * from "./LegacyMeterIntervalSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__